<template>
  <div class="container">
    <div class="top" v-if="isPC">
      <div></div>
<!--      <img class="logo" @click="toJump" src="../assets/images/home_logo.png" alt="">-->

      <div class="top_btn" v-if="currentPage != 1">
        <div class="btn1" @click="currentPage = 1">
          <img src="../assets/images/home.png" alt="">
          <span>返回主页</span>
        </div>
<!--        <div class="btn2" @click="toJump">-->
<!--          <img src="../assets/images/gw.png" alt="">-->
<!--          <span>返回官网</span>-->
<!--        </div>-->
      </div>
    </div>
    <div class="info-wrap">
      <div class="title-wrap">
        <span>专业技术人员信息管理查询系统</span>
        <span>INFORMATION MANAGEMENT QUERY SYSTEM</span>
      </div>
      <div class="con_wrap" :class="isPC?'con_wrap1':'con_wrap2'">
        <div class="left" v-if="isPC">
          <div class="zhanwei">
            <img src="@/assets/images/xing.png" alt="">
          </div>
          <div class="title-group" v-if="currentPage == 1" :class="currentPage == 1?'active':''" data-target="certificate">
            <div class="certificate" @click="toSearch(1)">职业技能人才培训证书</div>
          </div>
          <div class="title-group" v-if="currentPage == 2 || currentPage == 1" :class="currentPage == 2?'active':''" data-target="description">
            <div class="certificate" @click="toSearch(2)">证 书 说 明</div>
          </div>
<!--          <div class="title-group" v-if="currentPage == 3 || currentPage == 1" :class="currentPage == 3?'active':''" data-target="exam-center">-->
<!--            <div class="certificate" @click="toSearch(3)">考试中心</div>-->
<!--          </div>-->
<!--          <div class="title-group" v-if="currentPage == 4 || currentPage == 1" :class="currentPage == 4?'active':''" data-target="member-query">-->
<!--            <div class="certificate" @click="toSearch(4)">成员单位查询</div>-->
<!--          </div>-->
          <div class="title-group" v-if="currentPage == 2 || currentPage == 3 || currentPage == 4">
            <div class="certificate" @click="toSearch(1)">继续查询</div>
          </div>
          <div class="zhanwei1"></div>
        </div>
        <div class="line" v-if="isPC"></div>
        <div class="right">
          <div id="certificate" v-if="currentPage == 1" :class="currentPage == 1?'active':''" class="content">
           <p>职业技能人才培训证书</p>
            <span class="tishi1">您的个人信息已录入本系统，请输入相关信息查询，如查询有误请联系工作人员。</span>
<!--            <div class="form-group">-->
<!--              <img src="../assets/images/icon11.png" alt="">-->
<!--              <el-select style="width: 100%;border: none" v-model="form.certificate_type" placeholder="请选择证书类别">-->
<!--                <el-option v-for="(item,index) in typeList" :key="index" :label="item.name" :value="item.id"></el-option>-->
<!--              </el-select>-->
<!--            </div>-->
            <div class="certificate-bottom">
              <div class="certificate-left">
                <div class="form-group">
                  <img src="../assets/images/icon22.png" alt="">
                  <el-input type="text" id="name" placeholder="姓名" v-model="form.name" />
                </div>
                <div class="form-group">
                  <img src="../assets/images/icon33.png" alt="">
                  <el-input type="text" id="name" placeholder="证件号码" v-model="form.id_number" />
                </div>
                <div class="form-group">
                  <img src="../assets/images/icon44.png" alt="">
                  <el-input type="text" id="name" placeholder="证书编号" v-model="form.certificate_number" />
                </div>
              </div>
              <button class="btn" @click="toSubmit">查询</button>
            </div>
          </div>
          <div id="description" v-if="currentPage == 2" :class="currentPage == 2?'active':''" class="content">
            <p class="zh">证书使用说明</p>
            <div class="suoming">
              <span v-for="(item,index) in shiyong" :key="index">{{item.key}}</span>
            </div>
          </div>
          <div id="exam-center" v-if="currentPage == 3" :class="currentPage == 3?'active':''" class="content" style="padding: 50px 0 ">
<!--            <p>考试中心</p>-->
            <div class="form-group">
              <img src="../assets/images/icon33.png" alt="">
              <el-input v-model="form_ks.idCard" type="text" id="name" placeholder="证件号码" />
            </div>
            <div class="form-group">
              <img src="../assets/images/icon55.png" alt="">
              <el-input v-model="form_ks.password" type="password" id="name" placeholder="输入密码" />
            </div>
            <button class="btn" @click="toLogin">登录</button>
            <div class="tishi">* 如果无法登录，请联系组织单位专员</div>
          </div>
          <div id="member-query" v-if="currentPage == 4" :class="currentPage == 4?'active':''" class="content" style="padding: 50px 0 ">
<!--            <p>成员单位查询</p>-->
            <div class="form-group">
              <img src="../assets/images/icon66.png" alt="">
              <el-input type="text" id="name" v-model="form_cy.name" placeholder="单位名称" />
            </div>
            <div class="form-group">
              <img src="../assets/images/icon77.png" alt="">
              <el-input type="text" id="name" v-model="form_cy.code" placeholder="组织代码" />
            </div>
            <button class="btn" @click="toSubmit_CY">查询</button>
          </div>
        </div>
      </div>
      <div class="tips_wrap">
        <div class="tip">
          <div class="title">
            查询条件
          </div>
          <div class="sanjiao">
            <img src="../assets/images/jiao.png" alt="">
          </div>
          <div class="content">
            <span v-for="(item,index) in chaxun" :key="index">{{item.key}}</span>
          </div>
        </div>
        <div class="tip">
          <div class="title">
            注意事项与声明
          </div>
          <div class="sanjiao">
            <img src="../assets/images/jiao.png" alt="">
          </div>
          <div class="content1">
            <span v-for="(item,index) in zhuyi" :key="index">{{item.key}}</span>
            <span>{{zhuyiTitle.key}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  type_list,
  companyCertificate,
  userCertificate,
  configinfo
} from "@/api/index";
import {Base64} from 'js-base64';
export default {
  name: 'Home',
  components: {},
  data() {
    return {
      currentPage: 1,
      typeList:[],
      form:{
        certificate_type:'10',
        name:'',
        id_number:'',
        certificate_number:'',
      },
      chaxun:[],
      shiyong:[],
      zhuyi:[],
      zhuyiTitle: {},
      form_cy:{
        name:'',
        code:'',
      },
      form_ks:{
         idCard:'',
        password:'',
      },
      isPC:true
    };
  },
  mounted() {
    if (this.$route.query.index) {
      if (this.$route.query.index == 3) {
        this.currentPage = 4
      }else {
        this.currentPage = 1
      }
    }

    if (this.isMobile()) {
      this.isPC = false
    } else {
      this.isPC = true
    }

    this.getType()
    this.getInfo()
  },
  methods: {
    toJump(){
      window.open('https://zxx.org.cn/')
    },
    isMobile() {
      const ua = navigator.userAgent;
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
    },
    toSearch(num){
      this.currentPage = num
    },
    getType(){
      type_list().then(res => {
        if (res.code == 1) {
          this.typeList = res.data;
        }
      })
    },
    getInfo(){
      configinfo().then(res => {
        if (res.code == 1) {
          this.chaxun = res.data.chaxun;
          this.shiyong = res.data.shiyong;
          this.zhuyi = res.data.zhuyi;
          const last = this.zhuyi[this.zhuyi.length - 1];
          this.zhuyiTitle = last;
          this.zhuyi.splice(this.zhuyi.length - 1, 1);
        }
      })
    },
    toSubmit(){
      let ajax = {
        ...this.form
      }
      userCertificate(ajax).then(res => {
        if (res.code == 1) {
          if (res.data.length == 0) {
            this.$message({
              message: '暂无查询结果',
              type: 'warning'
            })
          }else{
            sessionStorage.setItem('userInfo',JSON.stringify(res.data))
            this.$router.push({
              path: 'result',
              query: { }
            })
          }
        }
      })
    },
    toSubmit_CY(){
      let ajax = {
        ...this.form_cy
      }
      companyCertificate(ajax).then(res => {
        if (res.code == 1) {
          if (res.data.length == 0) {
            this.$message({
              message: '暂无查询结果',
              type: 'warning'
            })
          }else{
            sessionStorage.setItem('companyInfo',JSON.stringify(res.data))
            this.$router.push({
              path: 'resultUser',
              query: { }
            })
          }
        }
      })
    },
    toLogin(){
      let ajax = {
        ...this.form_ks
      }
      if (this.form_ks.idCard.length != 18) {
        this.$message({
          message: '请输入正确的证件号码',
          type: 'warning'
        })
        return
      }
      let encodedText = Base64.encode( JSON.stringify(ajax));
      window.location.href = 'https://www.rsx.org.cn/login?type=1&encodedText=' + encodedText
    }
  }
};
</script>

<style scoped lang="scss">
/deep/.el-input__inner{
  border: none!important;
  color:#333333;
}
body {

}

.container {
  padding: 30px 50px 30px 50px;
  background: url('../assets/images/bg.png') no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  color: white;
  font-family: Arial, sans-serif;
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .logo{
    cursor: pointer;
  }
}

.top_btn {
  display: flex;
  align-items: center;
}

.top_btn .btn1 {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.top_btn .btn1 img {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}

.top_btn .btn2 {
  margin-left: 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.top_btn .btn2 img {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}

.top_btn span{
  font-size: 18px;
}

.info-wrap {
  text-align: center;
  margin-top: 50px;
}
.title-wrap{
  position: relative;
}
.info-wrap .title-wrap span:nth-child(1){
  font-family: PingFang SC;
  font-weight: 800;
  font-size: 42px;
  color: #FEFEFE;
  letter-spacing: 3px;
}

.info-wrap .title-wrap span:nth-child(2){
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 30px;
  color: #FFFFFF;
  opacity: 0.1;
  position: absolute;
  top: 18px;
  left: calc((100% - 660px)/2);
  text-align: center;
}

.con_wrap {
  margin: 50px auto 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  .line{
    display: flex;
    align-items: center;
    background-color: rgba(16, 150, 183, 1);
    width: 1px;
    height: 450px;
    margin: 0 90px;
  }
}

.con_wrap1 {
  max-width: 1296px;
  margin: 80px auto 0 auto;
  display: flex;
  justify-content: center;
  padding: 30px;
  box-sizing: border-box;
  width: 1296px;
  height: 550px;
  background: linear-gradient( 270deg, rgba(16, 150, 183, .7) 0%, rgba(6, 84, 157, .7) 100%);
  border-radius: 12px;
  //border: 1px solid #1096B7;
}


.con_wrap2 {
  margin: 50px auto 0 auto;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
}

.con_wrap .left {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 0 0 0;
  //background-image: url(../assets/images/kuang.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  //width: 400px;
  height: 540px;
  box-sizing: border-box;
}
.zhanwei{
  //height: 170px;
  margin-bottom: 40px;
  img{
    width: 120px;
    height: 120px;
  }
}

.zhanwei1{
  height: 56px;
}

.con_wrap .left .title-group {
  //width: 220px;
  min-width: 240px;
  padding: 0 20px;
  height: 68px;
  line-height: 68px;
  font-size: 20px;
  margin-bottom: 60px;
  border-radius: 8px;
  cursor: pointer;
  background: rgba(16, 150, 183, .6);
  font-family: PingFang SC;
  font-weight: 400;
  color: #ade8f7;
}

.con_wrap .left .title-group:last-child {
   margin-bottom: 0;
}

.left .title-group:hover {
  background-image: url(../assets/images/title_bg_act.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  color: #fff !important;
  font-weight: bold !important;
}

.left .active {
  background-image: url(../assets/images/title_bg_act.png) !important;
  background-repeat: no-repeat !important;
  background-size: 100% 100% !important;
  color: #fff !important;
  font-weight: bold !important;
}

.con_wrap .right {
  //width: 800px;
  //background-color: #216a98;
  //box-shadow: inset 0 0 24px rgba(7, 60, 94,.5);
  box-sizing: border-box;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 544px;
  width: 630px;
}

.con_wrap .right .content {
  width: 100%;
  display: none;

}

.con_wrap .right .content.active {
  width: 100%;
  display: block;
}
.tishi1{
  font-size: 14px;
  color: #fff;
  opacity: .8;
  margin-bottom: 60px;
  display: inline-block;
}

.con_wrap .right .form-group {
  background: rgba(16,16,53,0);
  box-shadow: inset 0 0 24px rgba(16, 150, 183, .8);
  border-radius: 6px;
  width: 100%;
  margin-bottom: 60px;
  height: 64px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  box-sizing: border-box;
  &:last-child{
    margin-bottom: 0;
  }
}

.con_wrap .right .form-group input {
  width: 100%;
  border: none;
  height: 56px;
  color: #000;
  margin-left: 10px;
  background: transparent;
}
/deep/.el-input__inner{
  background: transparent !important;
  color: #ffffff;
  font-size: 18px;
}

.con_wrap .right .form-group img {
  width: 28px;
  height: 28px;
}

.con_wrap .right .btn {
  width: 180px;
  height: 60px;
  background: rgba(16, 150, 183, 1);
  border: none;
  border-radius: 8px;
  color: #fff;
  font-size: 30px;
  font-weight: bold;
  font-family: cursive;
}

.con_wrap .right p {
  font-size: 30px;
  margin-bottom: 20px;
}

.suoming {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  //width: 80%;
  //margin: 0 auto;
}
.con_wrap .right .zh{
  margin-bottom: 50px;
}

.suoming span {
  text-align: left;
  font-size: 16px;
  margin-bottom: 20px;
}

.tishi {
  text-align: start;
  width: 80%;
  margin: 30px auto 0 auto;
  color: #da0011;
}

input::-webkit-input-placeholder {
  color: #000;
}

input:-moz-placeholder {
  color: #000;
}

input::-moz-placeholder {
  color: #000;
}

input:-ms-input-placeholder {
  color: #000;
}

.tips_wrap {
  margin: 20px auto 0 auto;
  //background-image: url(../assets/images/tip_bg.png);
  background: linear-gradient( 270deg, rgba(16, 150, 183, .7) 0%, rgba(6, 84, 157, .7) 100%);
  //background-repeat: no-repeat;
  //background-size: 100% 100%;
  max-width: 1296px;
  /* height: 200px; */
  box-sizing: border-box;
  padding: 20px 50px;
  border-radius: 12px;
}

.tips_wrap .tip {
  display: flex;

}

.tips_wrap .tip:nth-child(1) {
  border-bottom: 1px dashed #fff;
  padding-bottom: 20px;
}

.tips_wrap .tip:nth-child(2) {
  padding-top: 20px;
}

.tips_wrap .tip .title {
  font-size: 20px;
  font-family: fangsong;
  width: 170px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-weight: bold;
}

.tips_wrap .tip .sanjiao {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: 30px;
}

.tips_wrap .tip .sanjiao img {
  width: 18px;
  height: 10px;
}

.tips_wrap .tip .content {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  flex: 1;
  font-size: 13px;
}

.tips_wrap .tip .content span {
  width: 50%;
  text-align: start;
  margin-bottom: 10px;
}

.tips_wrap .tip .content span:last-child,
.tips_wrap .tip .content span:nth-last-child(2) {
  margin-bottom: 0;
}

.tips_wrap .tip .content1 {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  flex: 1;
  font-size: 13px;
}

.tips_wrap .tip .content1 span {
  width: 100%;
  text-align: start;
  margin-bottom: 10px;
}

.tips_wrap .tip .content1 span:last-child {
  color: #ff2637;
  margin-bottom: 0;
}
.tc{
  width: 40px;
  display: inline-block;
}
.certificate-bottom{
  display: flex;
  align-items: center;
  justify-content: center;
  .certificate-left{
    display: flex;
    flex-direction: column;
    width: 400px;
    margin-right: 50px;
  }
}



/* scoped 样式中修改 placeholder 颜色 */
::v-deep input::-webkit-input-placeholder {
  color: #ffffff;
  font-size: 18px;
}
::v-deep input::-moz-placeholder {
  color: #ffffff;
  font-size: 18px;
}
::v-deep input:-ms-input-placeholder {
  color: #ffffff;
  font-size: 18px;
}
::v-deep input:-moz-placeholder {
  color: #ffffff;
  font-size: 18px;
}
@media only screen and (max-width: 600px) {
  .title-wrap{
    position: relative;
  }
  .info-wrap .title-wrap span:nth-child(1){
    font-family: PingFang SC;
    font-weight: 800;
    font-size: 30px;
    color: #FEFEFE;
  }

  .info-wrap .title-wrap span:nth-child(2){
    font-family: PingFang SC;
    font-weight: bold;
    font-size: 24px;
    color: #FFFFFF;
    opacity: 0.1;
    position: absolute;
    top: 10px;
    left: calc((100% - 350px)/2);
    text-align: center;
  }
  .container{
    padding: 20px 20px;
  }
  .con_wrap .right{
    width: 100%;
    padding: 40px 0;
  }
  .con_wrap .right .form-group{
    height: 48px;
  }
  ::v-deep input::-webkit-input-placeholder {
    color: #ffffff;
    font-size: 14px;
  }
  ::v-deep input::-moz-placeholder {
    color: #ffffff;
    font-size: 14px;
  }
  ::v-deep input:-ms-input-placeholder {
    color: #ffffff;
    font-size: 14px;
  }
  ::v-deep input:-moz-placeholder {
    color: #ffffff;
    font-size: 14px;
  }
  .con_wrap .right .form-group img{
    width: 20px;
    height: 20px;
  }
  /deep/.el-input__inner{
    background: transparent !important;
    color: #ffffff;
    font-size: 14px;
  }
  .con_wrap .right .btn{
    height: 48px;
    font-size: 20px;
  }
  .tips_wrap{
    padding: 0 0;
    background-image:none;
  }
  .tips_wrap .tip{
    flex-direction: column;
  }
  .tips_wrap .tip .sanjiao{
    display: none;
  }
  .tips_wrap .tip .content{
    flex-direction: column;
  }
  .tips_wrap .tip .content span{
    width: 100%;
    margin-top: 10px;
  }
  .tips_wrap .tip .title{
    margin-bottom: 10px;
  }
  .tishi1{
    font-size: 14px;
    color: #fff;
    opacity: .8;
    margin-bottom: 40px;
    display: inline-block;
  }
  .certificate-bottom{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .certificate-left{
      display: flex;
      flex-direction: column;
      margin: 0;
      width: 100%;
    }
  }
  .con_wrap .right .btn {
    margin-top: 30px;
    width: 100%;
    height: 50px;
    background: rgba(16, 150, 183, 1);
    border: none;
    border-radius: 8px;
    color: #fff;
    font-size: 24px;
    font-weight: bold;
    font-family: cursive;
  }
}
</style>
